import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { PerformanceComponent } from './components/performance-at-a-glance/performance.component';
import { PerformanceRoutingModule } from './performance.routing.module';
import { SharedModule } from '../shared/shared.module';
import { ThirdPartyModule } from '../third-party/third-party.module';
import { PerformanceGoalTrackingComponent } from './components/performance-goal-tracking/performance-goal-tracking.component';
import { PerformanceReportsComponent } from './components/performance-reports/performance-reports.component';
import { PerformanceKpiComponent } from './components/performance-kpi/performance-kpi.component';
import { PerformanceInsightsKPIComponent } from './components/performance-insights-kpi/performance-insights-kpi.component';
import { PerformanceInsightsKPISparklineComponent } from './components/performance-insights-kpi-sparkline/performance-insights-kpi-sparkline.component';
import { PerformanceScorecardsComponent } from './components/performance-scorecards/performance-scorecards.component';
import { PerformanceTransitionComponent } from './components/performance-transition/performance-transition.component';
import { PerformanceUpgradeComponent } from './components/performance-upgrade/performance-upgrade.component';
import { PerformanceInsightOptionComponent } from './components/performance-insight-option/performance-insight-option.component';
import { PerformanceScorecardEmployeeTypeComponent } from './components/performance-scorecard-employee-type/performance-scorecard-employee-type.component';
import { PerformanceScorecardEntityComponent } from './components/performance-scorecard-entity/performance-scorecard-entity.component';
import { PerformanceScorecardThirdPartyComponent } from './components/performance-scorecard-third-party/performance-scorecard-third-party.component';
import { PerformanceInsightsComponent } from './components/performance-insights/performance-insights.component';
import { PerformanceProjectionsConfigComponent } from './components/performance-projections-config/performance-projections-config.component';
import { PerformanceInsightsKpiLOComponent } from './components/performance-insights-kpi-lo/performance-insights-kpi-lo.component';
import { PerformanceInsightWeightedRankingsComponent } from './components/performance-insight-weighted-rankings/performance-insight-weighted-rankings.component';
import { PerformanceRankingsPositionComponent } from './components/performance-rankings-position/performance-rankings-position.component';
import { PerformanceInsightRankingTableComponent } from './components/performance-insight-weighted-rankings/table/performance-insight-ranking-table.component';
import { PerformanceBranchLeaderboardComponent } from './components/performance-branch-leaderboard/performance-branch-leaderboard.component';
import { PerformanceRankingsBranchComponent } from './components/performance-rankings-branch/performance-rankings-branch.component';
import { PerformanceInsightsMonthlyLoRankingsComponent } from './components/performance-insights-monthly-lo-rankings/performance-insights-monthly-lo-rankings.component';
import { PerformanceActualsVsProjectionsComponent } from './components/performance-actuals-vs-projections/performance-actuals-vs-projections.component';
import { PerformanceActualsVsProjectionsTableComponent } from './components/performance-actuals-vs-projections/table/performance-actuals-vs-projections-table/performance-actuals-vs-projections-table.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { EntityLeaderboardService } from './services/entity-leaderboard.service';
import { PerformanceScorecardService } from './services/performance-scorecard.service';
import { PerformanceService } from './services/performance.service';
import { ProjectionService } from './services/projection.service';
import { RankingsService } from './services/rankings.service';

@NgModule({
    declarations: [
        PerformanceComponent,
        PerformanceGoalTrackingComponent,
        PerformanceReportsComponent,
        PerformanceKpiComponent,
        PerformanceInsightsKPIComponent,
        PerformanceInsightsKPISparklineComponent,
        PerformanceScorecardsComponent,
        PerformanceTransitionComponent,
        PerformanceUpgradeComponent,
        PerformanceInsightOptionComponent,
        PerformanceScorecardEmployeeTypeComponent,
        PerformanceScorecardEntityComponent,
        PerformanceScorecardThirdPartyComponent,
        PerformanceInsightsComponent,
        PerformanceProjectionsConfigComponent,
        PerformanceInsightsKpiLOComponent,
        PerformanceInsightWeightedRankingsComponent,
        PerformanceRankingsPositionComponent,
        PerformanceInsightRankingTableComponent,
        PerformanceBranchLeaderboardComponent,
        PerformanceRankingsBranchComponent,
        PerformanceInsightsMonthlyLoRankingsComponent,
        PerformanceActualsVsProjectionsComponent,
        PerformanceActualsVsProjectionsTableComponent,
    ],
    imports: [CommonModule, PerformanceRoutingModule, SharedModule, GridModule, ThirdPartyModule],
    providers: [
        CurrencyPipe,
        DecimalPipe,
        EntityLeaderboardService,
        PerformanceScorecardService,
        PerformanceService,
        ProjectionService,
        RankingsService,
    ],
    schemas: [NO_ERRORS_SCHEMA],
})
export class PerformanceModule {}
